import { supabase } from "@/lib/supabase";
import { Icon } from "./Icon";
import { useSearchParams } from "react-router";
import { useCallback } from "react";

/**
 * Redirect-based Google sign-in used for environments where popup windows are blocked
 * (for example VS Code integrated browser).
 */
export const GoogleSignInRedirectButton: React.FC = () => {
  const [searchParams] = useSearchParams();

  const handleRedirectSignIn = useCallback(() => {
    // Redirect back to the /unathenticated page, including any returnUrl parameter from the current URL
    // The /unathenticated page handles the redirect and will send the user back to the returnUrl after successful sign-in
    const returnUrl = searchParams.get("returnUrl") || "/";
    const redirectTo = window.location.origin + "/unauthenticated?returnUrl=" + encodeURIComponent(returnUrl);

    void supabase.auth
      .signInWithOAuth({ provider: "google", options: { redirectTo } })
      .then(({ error }) => {
        if (error) throw error;
      })
      .catch((error: unknown) => {
        console.error("Google OAuth redirect sign-in failed", error);
      });
  }, [searchParams]);

  return (
    <button type="button" className="btn btn-outline-secondary" onClick={handleRedirectSignIn}>
      <Icon icon="google" className="text-body me-2" aria-hidden="true" />
      <span>Sign in</span>
    </button>
  );
};
